<template>
  <div>
    <page-header
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
      class="mt-3 mt-md-0"
      @onReturn="() => $router.back()"
      :has-return="true"
    />
    <filter-manager
      ref="filterRef"
      :display-advanced="false"
      class="search-bar"
      search-icon="fa fa-sync"
      search-text="Procesar"
      search-container-class="btn-process"
      v-model="model.search.filters"
      :filters="filterManagerConfig"
      @search="onHandlerSearch"
    />
  </div>
</template>

<script>
// libs
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';

// utils
import storeMixin from 'utils/mixins/storeGenerator';

// services
import DocumentServices from '@/modules/report/document';
import AcademicYearServices from '@/services/api/academicyear.api';
import ReportServices from '@/modules/report/api';

// constants
const STORE_MODULE_NAME = 'ReferralEquitableServicesModule';

export default {
  name: 'ReferralEquitableServices',
  components: {
    PageHeader,
    FilterManager,
  },
  mixins: [storeMixin],
  data: () => ({
    moduleName: STORE_MODULE_NAME,
    model: {
      search: {
        collections: {
          academicYears: [],
        },
        filters: {
          academicYear: null,
        },
      },
    },
  }),
  computed: {
    headerConfig() {
      return {
        title: 'Referidos Servicios Equitativos',
        icon: 'fas fa-file-invoice pr-0 font-22 magnifying-glass-icon-m ',
        routes: ['Inicio', 'Referidos Servicios Equitativos'],
      };
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'description',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'El año académico es requerido.',
          validations: 'required',
          clearable: false,
          class: 'col-12 col-md-3',
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
        },
      ];
    },
  },
  async mounted() {
    await this.setFilters();
  },
  methods: {
    async setFilters() {
      const {
        data: years,
      } = await AcademicYearServices.getCurrentYearAcademicYears();
      this.model.search.collections.academicYears = [...years];
      this.model.search.filters.academicYear = years[0];
    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();
      if (isValid) {
        await this.process();
      }
    },
    async process() {
      if (this.model.search.filters.academicYear?.id) {
        await ReportServices.getReport('referralequitableservices', {
          academicYearId: this.model.search.filters.academicYear.id,
        }).then((res) => DocumentServices.Download(res.data));
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
